import { AddOnQuantityRange, BookingAddOnSubmission, QuantityBounds, QuantityViolation } from './types';

/*
 * A zero minimum means one, and an absent maximum means unbounded rather than zero. An unresolved
 * range therefore yields floor 1 and max Infinity, which is what makes every caller fail open.
 */
export const deriveBounds = (range?: AddOnQuantityRange): QuantityBounds => {
  const min = Math.max(1, range?.minQuantity ?? 0);

  return { min, max: Math.max(min, range?.maxQuantity ?? Number.POSITIVE_INFINITY) };
};

export const findQuantityViolations = (
  lines: Array<BookingAddOnSubmission>,
  ranges: Record<string, AddOnQuantityRange>,
): Array<QuantityViolation> =>
  lines
    .map(line => ({ line, ...deriveBounds(ranges[line.id.toLowerCase()]) }))
    .filter(({ line, min, max }) => line.quantity > max || line.quantity < min)
    .map(({ line, min, max }) => ({ id: line.id, name: line.name, quantity: line.quantity, min, max }));
